import { render, staticRenderFns } from "./comments_manage.vue?vue&type=template&id=e0efbcc2&scoped=true&"
import script from "./comments_manage.vue?vue&type=script&lang=js&"
export * from "./comments_manage.vue?vue&type=script&lang=js&"
import style0 from "./comments_manage.vue?vue&type=style&index=0&id=e0efbcc2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0efbcc2",
  null
  
)

export default component.exports